import type { GaApp } from '~/modules/app'
import type { PrizeModel } from '~/modules/main'

export const getters = (gaApp: GaApp) => ({
  sortedByTypeAvailablePrizes(): PrizeModel[] | [] {
    if (!gaApp.stores.main.user.isAuthorized) return []

    const allPrizes = gaApp.stores.main.main.allRoulettePrizes
    const forbiddenPrizes = gaApp.stores.main.user.data?.forbiddenPrizes
    const availablePrizes =
      forbiddenPrizes && forbiddenPrizes.length > 0
        ? allPrizes.filter((prize) => !forbiddenPrizes.includes(prize.id))
        : allPrizes

    const order = ['physical', 'bonus', 'coins', 'promo-code']

    return availablePrizes.slice().sort((a, b) => {
      const indexA = order.indexOf(a.prizeDescription.type)
      const indexB = order.indexOf(b.prizeDescription.type)
      const typeDiff = indexA - indexB
      if (typeDiff !== 0) return typeDiff

      const orderA = Number(
        a.prizeDescription.sortOrder ?? Number.POSITIVE_INFINITY,
      )
      const orderB = Number(
        b.prizeDescription.sortOrder ?? Number.POSITIVE_INFINITY,
      )
      if (orderA !== orderB) return orderA - orderB

      return String(a.id).localeCompare(String(b.id))
    })
  },
  actualRoulettePrice(): number {
    const FREE_SPIN_PRICE = 0

    return gaApp.stores.main.user.data?.freeSpin
      ? FREE_SPIN_PRICE
      : (gaApp.stores.main.user.data?.oneSpinPrice ?? 0)
  },
})
